import Loader from './Loader';

interface FullScreenLoaderProps {
  size?: number;
}

export default function FullScreenLoader({ size = 140 }: FullScreenLoaderProps) {
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center">
      <Loader size={size} />
    </div>
  );
}
